/*window.tryRun("buttonfix", function () {
    var canvas = document.createElement("canvas");

	let getTextWidth = function (element, style) {
        var context = canvas.getContext("2d");
		context.font = style.fontWeight +  ' ' + style.fontSize + ' ' + style.fontFamily;
        var metrics = context.measureText(element.innerText);

		return metrics.width;
    };

    let checkVisible = function (element) {
        var el = element;
        do {
            var s = window.getComputedStyle(el);

            if (s.display == 'none')
                return false;

            el = el.parentElement;
        } while (el);

        return true;
    };

    var buttonWatch = document.createElement("a");
    var oldButtonWidth = 0;
    var allButtons = [];

    //var oldWidth = 0;
    //var oldHeight = 0;

    let getButtonWidth = function (button) {
        var buttonStyle = window.getComputedStyle(button);
        var afterStyles = window.getComputedStyle(button, ":after");

        var padding = parseInt(buttonStyle.paddingLeft, 10) + parseInt(buttonStyle.paddingRight, 10);
        var afterWidth = parseInt(afterStyles.width, 10);

        var width = getTextWidth(button, buttonStyle);

        return width + padding + afterWidth;
    };

    let checkButtons = function () {

        //if (oldWidth == window.innerWidth && oldHeight == window.innerHeight)
            //return;

        //oldWidth = window.innerWidth;
        //oldHeight = window.innerHeight;

        var buttonWidth = getButtonWidth(buttonWatch);
        var sizeChanged = buttonWidth != oldButtonWidth;
        oldButtonWidth = buttonWidth;

        for (var i = 0; i < allButtons.length; i++) {
            var parentRect = allButtons[i].parent.getBoundingClientRect();
            if (allButtons[i].width == parentRect.right - parentRect.left && allButtons[i].height == parentRect.bottom - parentRect.top)
                continue;
            sizeChanged = true;
            allButtons[i].width = parentRect.right - parentRect.left;
            allButtons[i].height = parentRect.bottom - parentRect.top;
        }

        if (!sizeChanged)
            return;

        for (var i = 0; i < allButtons.length; i++) {
            var button = allButtons[i].button;
            button.classList.remove("button-1");
            button.classList.remove("button-2");
            button.classList.remove("button-3");
            button.classList.remove("button-4");
            button.classList.remove("button-5");
            button.classList.remove("button-6");
            button.classList.remove("button-7");
            button.classList.remove("button-8");
            button.classList.remove("button-9");
        }

        for (var i = 10; i > 0; i--) {
            var sizeOk = true;
            for (var j = 0; j < allButtons.length; j++) {
                var button = allButtons[j].button;

                if (!checkVisible(button))
                    continue;

                /*var buttonStyle = window.getComputedStyle(button);
                var afterStyles = window.getComputedStyle(button, ":after");

                var padding = parseInt(buttonStyle.paddingLeft, 10) + parseInt(buttonStyle.paddingRight, 10);
                var afterWidth = parseInt(afterStyles.width, 10);

                //var parentRect = allButtons[j].parent.getBoundingClientRect();
                //var parentWidth = parentRect.right - parentRect.left;

                var width = getButtonWidth(button);

                //allButtons[j].div2.style.width = ((width + padding + afterWidth) * (i / 10)) + "px";

                sizeOk &= ((width * (i / 10)) < allButtons[j].width);
            }
            if (!sizeOk)
                continue;
            if (i < 10) {
                for (var j = 0; j < allButtons.length; j++) {
                    allButtons[j].button.classList.add("button-" + i);
                    allButtons[j].div1.style.height = ((44 + 24.2) * (i / 10)) + "px"
                }
            } else {
                for (var j = 0; j < allButtons.length; j++) {
                    allButtons[j].div1.style.height = (44 + 24.2) + "px"
                }
            }
            break;
        }
    };

    var recheckTimeout = 0;

    let setupButtons = function () {
        var buttons = document.getElementsByClassName("button");

        Array.prototype.forEach.call(buttons, function (button) {
            var btn = {
                button: button,
                parent: button.parentElement,
                iframe: null,
                div1: null,
                div2: null,
                width: 0,
                height: 0,
            };
            btn.iframe = document.createElement("iframe");
            btn.iframe.style.position = "absolute";
            btn.iframe.style.left = "0";
            btn.iframe.style.top = "0";
            btn.iframe.style.right = "0";
            btn.iframe.style.height = "0";
            btn.iframe.style.width = "100%";
            btn.iframe.style.border = "0";
            btn.iframe.style.backgroundColor = "transparent";

            btn.div1 = document.createElement("div");
            //btn.div1.style.display = "inline-block";
            btn.div1.style.position = "relative";
            btn.div1.style.left = "0";
            btn.div1.style.right = "0";

            btn.div2 = document.createElement("div");
            //btn.div2.style.display = "inline-block";
            btn.div2.style.position = "absolute";
            btn.div2.style.width = "100%";

            btn.parent.insertBefore(btn.div1, btn.button.nextSibling);
            btn.parent.removeChild(btn.button);
            btn.div1.appendChild(btn.div2);
            btn.div2.appendChild(btn.button);

            btn.parent.appendChild(btn.iframe);
            //btn.button.style.position = "absolute";

            btn.iframe.contentWindow.addEventListener("resize", function () {
                if (recheckTimeout != 0)
                    clearTimeout(recheckTimeout);
                recheckTimeout = setTimeout(checkButtons, 100);
            });

            var parentRect = btn.parent.getBoundingClientRect();
            btn.width = parentRect.right - parentRect.left;
            btn.height = parentRect.bottom - parentRect.top;

            allButtons.push(btn);
        });

        buttonWatch.classList.add("button");
        buttonWatch.style.position = "fixed";
        buttonWatch.style.visibility = "hidden";
        buttonWatch.style.top = "0px";
        buttonWatch.style.left = "0px";
        document.body.appendChild(buttonWatch);
    };

    document.addEventListener("DOMContentLoaded", function () {
        for (var i = 0; i < allButtons.length; i++) {
            allButtons[i].width = 0;
            allButtons[i].height = 0;
        }
        var startupCheck = setInterval(checkButtons, 100);
        setTimeout(function () {
            clearInterval(startupCheck);
        }, 10000);
    });

    //setInterval(checkButtons, 1000);

    //window.addEventListener("resize", checkButtons);

    setupButtons();
    checkButtons();
});*/